import { useEffect, useRef } from 'react';

/**
 * Syncs field array values to RHF Controllers after they mount.
 * Works around RHF v6 Controller defaultValue override — Controller's
 * defaultValue: '' overrides values set by useFieldArray. This effect
 * runs after the re-render where Controllers registered, updating them
 * with the correct values.
 *
 * @param {string} fieldArrayName - RHF field array path (e.g. 'testConfig.httpHeaders')
 * @param {Array} fields - fields from useFieldArray
 * @param {Function} setValue - from useFormContext
 * @param {string[]} propertyNames - field properties to sync (e.g. ['name', 'value'])
 * @param {boolean} [condition=true] - optional gate (e.g. showPostData)
 */
const useSyncedFieldArray = (fieldArrayName, fields, setValue, propertyNames, condition = true) => {
    const syncedRef = useRef(false);
    useEffect(() => {
        if (condition && fields.length > 0 && !syncedRef.current) {
            syncedRef.current = true;
            fields.forEach((field, index) => {
                propertyNames.forEach((prop) => {
                    setValue(`${fieldArrayName}[${index}].${prop}`, field[prop] || '');
                });
            });
        }
    }, [condition, fieldArrayName, fields, propertyNames, setValue]);
};

export default useSyncedFieldArray;
